import * as React from 'react';
import { Entity, PermissionLevel } from '../utilities/Permisos';
import { Divider, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper } from '@mui/material';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import SecurityTrimmer from './Utilities/SecurityTrimmer';
import EntityPermissions from './EntityPermissions';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import EntityNotifications from '../Notificaciones/EntityNotifications';
import FeatureManager from './Utilities/FeatureManager';

export interface IEntitySettingsProps {
    entity: Entity;
}

export interface IEntitySettingsState {
    menuOpened: boolean;
}

export default class EntitySettings extends React.Component<IEntitySettingsProps, IEntitySettingsState> {
    public constructor(props: IEntitySettingsProps) {
        super(props);

        this.state = {
            menuOpened: false
        }
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                <IconButton onClick={this.Open.bind(this)}>
                    <SettingsOutlinedIcon/>
                </IconButton>
                <Paper square elevation={3} className='settingsbar' style={{right: '-500px'}}>
                    <IconButton onClick={this.Open.bind(this)}>
                        <CloseOutlinedIcon/>
                    </IconButton>
                    <List disablePadding>
                        <ListItem disablePadding>
                            <EntityNotifications entity={this.props.entity} onOpen={this.Open.bind(this)} />
                        </ListItem>
                        <FeatureManager entidad={this.props.entity} operacion='Administrar'>
                            <SecurityTrimmer entity={this.props.entity} permission={PermissionLevel.Administrar}>
                                <ListItem disablePadding>
                                    <EntityPermissions entity={this.props.entity} onOpen={this.Open.bind(this)} showAsButton={false}/>
                                </ListItem>
                            </SecurityTrimmer>
                        </FeatureManager>
                    </List>
                </Paper>
            </React.Fragment>
        )
    }

    private Open() {
        if((document.querySelector('.settingsbar')! as HTMLElement).style.right == "-500px") {
            (document.querySelector('.settingsbar')! as HTMLElement).style.right = "0px";
        }
        else {
            (document.querySelector('.settingsbar')! as HTMLElement).style.right = "-500px";
        }
    }
}